import React, {memo, useMemo} from 'react';
import styles from './styles.module.scss';
import {TimeRangeEnum} from "@/app/api/open_match";
import {t} from "i18next";
import {s} from "@/app/utils/s";
import SelectionWidget from "@/app/components/selection_widget";

interface Props {
  onSelect?: (value: TimeRangeEnum) => void;
  value?: TimeRangeEnum;
}

const TimeRangeWidget: React.FC<Props> = ({onSelect, value}) => {
  const options = useMemo(() => [
    { value: TimeRangeEnum.MORNING, label: t(s.morning) },
    { value: TimeRangeEnum.MIDDAY, label: t(s.midday) },
    { value: TimeRangeEnum.EVENING, label: t(s.evening) },
  ], []);

  return (
    <SelectionWidget
      title={t(s.selectTimeRange)}
      options={options}
      selectedValue={value}
      onSelect={onSelect}
      className={styles.timeRangeWidget}
    />
  );
};

export default memo(TimeRangeWidget);
